import React from "react";
import { DealQuestionnaire } from "@/pages/deals/types";
import QuestionnaireCard from "./QuestionnaireCard";

interface WorkflowListProps {
  questionnaires?: DealQuestionnaire[];
  stageId?: string;
}

const WorkflowList: React.FC<WorkflowListProps> = ({
  questionnaires,
  stageId
}) => {
  return (
    <div className="flex flex-col h-full max-h-[700px]">
      {questionnaires && questionnaires.length > 0 && (
        <div className="flex-1 overflow-y-auto p-6">
          <div className="flex flex-col gap-4">
            {questionnaires.map(
              (questionnaire: DealQuestionnaire, index: number) => (
                <QuestionnaireCard
                  key={questionnaire.id || index}
                  questionnaire={questionnaire}
                  stageId={stageId}
                />
              )
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default WorkflowList;
